import React from 'react';

import Typography from 'components-new/typography/typography';

import { createLocale } from 'locales';

import HeaderDialog from '../components/freelancer-sign-up-page-container/header-dialog';

type DialogInstructionsContentProps = {
  isOpen: boolean;
  onCloseClicked: () => void;
};
const DialogInstructionsContent: React.FC<DialogInstructionsContentProps> = ({
  isOpen,
  onCloseClicked,
}) => {
  const localize = createLocale('freelancerSubmitApplicationPageLocales');
  const globalLocalize = createLocale('global');
  return (
    <HeaderDialog
      onCloseClicked={onCloseClicked}
      isOpen={isOpen}
      title={localize('title')}
      buttonProps={{
        label: globalLocalize('goBack'),
        onClick: onCloseClicked,
        variant: 'primary',
      }}
      className="max-w-[80%] lg:max-w-[60%]"
    >
      <Typography variant="body-medium" as="p" className="mb-2">
        {localize('instructions1')}
      </Typography>
      <Typography variant="body-medium" as="p" className="mb-2">
        {localize('instructions2')}
      </Typography>
      <Typography variant="body-medium" as="p" className="mb-2">
        {localize('instructions3')}
      </Typography>
      <Typography variant="body-medium" as="p" className="mb-2">
        {localize('instructions4')}
      </Typography>
      <Typography variant="body-medium" as="p" className="mb-2">
        {localize('instructions5')}
      </Typography>
    </HeaderDialog>
  );
};

export default DialogInstructionsContent;
